import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createSlots as _createSlots, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex gap-6 align-items-end" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative mt-2" }
const _hoisted_6 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", { class: "text-danger cursor-pointer" }, "Reset", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "card-toolbar" }
const _hoisted_10 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_11 = { class: "svg-icon svg-icon-2" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Add New Applicant ")
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = { class: "symbol symbol-circle symbol-50px overflow-hidden me-4" }
const _hoisted_15 = { class: "symbol-label fs-3 bg-light-danger text-danger" }
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = { class: "text-gray-800 text-hover-primary mb-1" }
const _hoisted_18 = ["onClick", "title", "disabled"]
const _hoisted_19 = ["onClick", "data-bs-target"]
const _hoisted_20 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("View ")
const _hoisted_22 = ["onClick", "data-bs-target"]
const _hoisted_23 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("View ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ViewVerificationModal = _resolveComponent("ViewVerificationModal")!
  const _component_AMLVerificationModal = _resolveComponent("AMLVerificationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
                class: "form-control form-control-solid w-250px ps-15",
                placeholder: "Search Submitted Clients"
              }, null, 544), [
                [_vModelText, _ctx.search]
              ])
            ]),
            _createElementVNode("div", null, [
              (_ctx.verificationType)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.verificationType = null))
                  }, _hoisted_8))
                : _createCommentVNode("", true),
              _createVNode(_component_el_select, {
                placeholder: "Filter by",
                modelValue: _ctx.verificationType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.verificationType) = $event)),
                clearable: "",
                size: "large"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.PlanTypes), (planType) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: planType,
                      label: _ctx.PlanTypes[planType],
                      value: planType
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: { name: 'customer-setup-verification' },
              type: "button",
              class: "btn btn-primary"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                ]),
                _hoisted_12
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["card-body pt-0", { 'opacity-50': _ctx.loadingClients }])
      }, [
        (_openBlock(), _createBlock(_component_Datatable, {
          key: _ctx.tableKey,
          "table-data": _ctx.tableData,
          "table-header": 
          _ctx.$route.params?.progressStatus !== 'inProgress'
            ? _ctx.tableHeaderWithActions
            : _ctx.tableHeaderWithoutActions
        ,
          "enable-items-per-page-dropdown": true,
          loading: _ctx.loadingClients
        }, _createSlots({
          "cell-email": _withCtx(({ row: customer }) => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getClientInitials(customer)), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1),
                _createElementVNode("span", null, _toDisplayString(customer.email), 1)
              ])
            ])
          ]),
          "cell-plan": _withCtx(({ row: customer }) => [
            _createTextVNode(_toDisplayString(customer.plan_verbose?.plan_type_verbose), 1)
          ]),
          "cell-company": _withCtx(({ row: customer }) => [
            _createTextVNode(_toDisplayString(customer.company_verbose?.company_name), 1)
          ]),
          "cell-created": _withCtx(({ row: customer }) => [
            _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(customer.created)), 1)
          ]),
          "cell-status": _withCtx(({ row: customer }) => [
            _createVNode(_component_Badge, {
              variant: _ctx.$filters.getStatusBadgeVariant(customer.status)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(customer.verification?.status_verbose ||
            _ctx.$filters.getStatusLabel(customer.status)), 1)
              ]),
              _: 2
            }, 1032, ["variant"])
          ]),
          _: 2
        }, [
          (_ctx.$route.params?.progressStatus !== 'inProgress')
            ? {
                name: "cell-actions",
                fn: _withCtx(({ row: customer }) => [
                  (
              customer?.verification?.id &&
              customer.plan_verbose?.plan_type !== _ctx.PlanType.ID_VERIFICATION &&
              customer.plan_verbose?.plan_type !== _ctx.PlanType.AML_VERIFICATION
            )
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.reviewForm(customer, $event)), ["stop"]),
                        class: "btn btn-sm btn-bg-light btn-active-color-primary",
                        title: customer.status == 1 ? 'Pending Submission' : '',
                        disabled: customer.status == 1
                      }, "Open ", 8, _hoisted_18))
                    : _createCommentVNode("", true),
                  (
              customer?.verification?.id &&
              customer.plan_verbose?.plan_type === _ctx.PlanType.ID_VERIFICATION
            )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _withModifiers(($event: any) => (_ctx.viewVerification(customer.verification?.id)), ["stop"]),
                        class: "btn btn-sm btn-light btn-active-light-primary m-1",
                        "data-bs-toggle": "modal",
                        "data-bs-target": `#${_ctx.$modals.VIEW_VERIFICATION_MODAL}`
                      }, [
                        _createElementVNode("span", _hoisted_20, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                        ]),
                        _hoisted_21
                      ], 8, _hoisted_19))
                    : _createCommentVNode("", true),
                  (
              customer?.verification?.id &&
              customer.plan_verbose?.plan_type === _ctx.PlanType.AML_VERIFICATION
            )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _withModifiers(($event: any) => (_ctx.handleFetchClientVerification(customer.id, 'aml')), ["stop"]),
                        class: "btn btn-sm btn-light btn-active-light-primary m-1",
                        "data-bs-toggle": "modal",
                        "data-bs-target": `#${_ctx.$modals.VIEW_AML_VERIFICATION_MODAL}`
                      }, [
                        _createElementVNode("span", _hoisted_23, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                        ]),
                        _hoisted_24
                      ], 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["table-data", "table-header", "loading"]))
      ], 2)
    ]),
    _createVNode(_component_ViewVerificationModal, {
      verification: _ctx.activeIDVerification,
      "is-admin": _ctx.isAdmin,
      loading: _ctx.loadingIDVerification,
      onUpdated: _ctx.handleVerificationUpdated
    }, null, 8, ["verification", "is-admin", "loading", "onUpdated"]),
    _createVNode(_component_AMLVerificationModal, {
      verification: _ctx.selectedAMLVerification,
      loading: _ctx.loadingVerification
    }, null, 8, ["verification", "loading"])
  ], 64))
}